<template>
  <div v-if="breadcrumbs.length > 1"
       class="breadcrumbs col-grow">
    <ul class="breadcrumbs__list">
      <breadcrumb v-for="(breadcrumb, index) in breadcrumbs"
                  :key="index"
                  :label="breadcrumb.title"
                  :to="breadcrumb.url"
                  :active="index === breadcrumbs.length - 1" />
    </ul>
  </div>

</template>

<script>
import Breadcrumb from './Breadcrumb'

export default {
  components: { Breadcrumb },
  computed: {
    breadcrumbs () {
      if (typeof window.breadcrumbs === 'string') {
        console.error('Unable to render breadcrumbs', window.breadcrumbs)
        return []
      }
      if (window.breadcrumbs.length === 0) {
        console.warn(`No breadcrumbs registered for page [${this.$route().current()}]`)
      }
      return window.breadcrumbs
    },
    previousPage () {
      if (this.breadcrumbs.length <= 1) return ''
      return this.breadcrumbs[this.breadcrumbs.length - 1].url
    },
  },
}
</script>
